import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NotifyDialogComponent } from './notify-dialog.component';
import { CustomMaterialModule } from '@sk/custom-material';


@NgModule({
  declarations: [
    NotifyDialogComponent
  ],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FlexLayoutModule
  ],
})
export class NotifyDialogModule {
}
